import PtIcon from '@patsnap-biz/icon';
import PtVirtualTree from '@patsnap-biz/virtual-tree';
import '@patsnap-ui/icon/assets/solid/CheckboxOn.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOff.svg';
import { NODE_HIGH_LIGHT_EXP } from '../utils';
export default {
    name: 'OptionFieldPane',
    components: {
        PtVirtualTree,
        PtIcon,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            type: Array,
            default: null,
        },
        field: {
            type: Object,
            required: true,
        },
        filter: {
            type: String,
            default: '',
        },
    },
    methods: {
        isChecked(optionId) {
            var _a;
            return (_a = this.value) === null || _a === void 0 ? void 0 : _a.includes(optionId);
        },
        getNodeName(name) {
            const $name = name || '';
            if (!this.filter)
                return $name;
            const $filter = (this.filter || '').toLowerCase().replace(NODE_HIGH_LIGHT_EXP, '\\$&');
            return $name.replace(new RegExp($filter, 'ig'), (i) => `<span class="custom-field-label-pane__option-field-pane__item__highlight-node-name">${i}</span>`);
        },
        filterNodeMethod({ data }, filter) {
            const $filter = filter.toLowerCase();
            const $name = (data.option_text || '').toLowerCase();
            return $name.indexOf($filter) > -1;
        },
        toggleCheck(optionId) {
            const newValue = [...(this.value || [])];
            if (this.isChecked(optionId)) {
                newValue.splice(newValue.indexOf(optionId), 1);
            }
            else {
                newValue.push(optionId);
            }
            this.$emit('change', newValue);
        },
    },
};
